import { Component, OnInit } from '@angular/core';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';
import { Router } from '@angular/router';
import { ToastEvokeService } from '@costlydeveloper/ngx-awesome-popup';
import { AuthenticationService } from '../../services/authentication.service';
import { ActivatedRoute } from '@angular/router';
import { AppSettings } from '../../app-settings';

@Component({
  selector: 'app-login',
  //templateUrl: './login.component.html',
  template: '',
  styleUrls: ['./login.component.scss'],
})
export class LoginComponent implements OnInit {
  public login: FormGroup;

  constructor(
    private fb: FormBuilder,
    private toastEvokeService: ToastEvokeService,
    private authenticationService: AuthenticationService,
    private router: Router,
    private activatedRoute: ActivatedRoute
  ) {
    this.login = this.fb.group({
      email: new FormControl('', [Validators.required, Validators.email]),
      password: new FormControl('', [Validators.required]),
    });
  }

  ngOnInit(): void {
    //  if (localStorage.getItem("jwt_token") !== null) {
    //   this.router.navigate(['/select-cashregister']);
    // } else {
      this.activatedRoute.params.subscribe((params) => {
        const token = params['token'];
        const business = params['business'];
        if (business) {
          localStorage.setItem('id_business', business);
        }

        if (token) {
          localStorage.setItem('jwt_token', token);
          this.router.navigate(['/select-cashregister']);
        }
      });
    // }
  }

  authenticate($event: any) {
    let buttonElement: HTMLElement = $event.srcElement;
    buttonElement.classList.add('pulse');
    setTimeout(function () {
      buttonElement.classList.remove('pulse');
    }, 400);
    if (!this.login.valid) {
      this.toastEvokeService
        .danger('Datos incorrectos', 'Revisa los datos del formulario')
        .subscribe();
    }
    this.authenticationService.login(this.login.value).subscribe(
      (data) => {
        this.router.navigate(['/select-cashregister']);
      },
      (error) => {
        this.toastEvokeService
          .danger('Datos incorrectos', 'Usuario o contraseña incorrectos')
          .subscribe();
      }
    );
  }
}
